module.exports = __webpack_public_path__ + "img/message-lines.fe358cad.svg";